import { Title } from "../shared/title/title.tsx";
import './contacts.css';

function Contacts() {
    return <div id='contacts' className="animated">
        <Title value="Contacts" />
        <div id='contacts-container'>
           <a href="mailto:hmthcband@gmail.com">hmthcband@gmail.com</a>
        </div>
        </div>
}

export {Contacts}